export default __webpack_public_path__ + "static/media/smart-button-icon.69adc39e.svg";